import { FieldLabel, RequiredStar, FieldError } from './styles';

export function Field({ id, label, required, error, tight, children }) {
  return (
    <div>
      <FieldLabel htmlFor={id}>
        {label}{required && <RequiredStar> *</RequiredStar>}
      </FieldLabel>
      {children}
      {error && <FieldError $tight={tight}>{error}</FieldError>}
    </div>
  );
}
